module.exports = __webpack_public_path__ + "c9e60f60c3d0b5a1d6b02f882a8d4b8a.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/war_has_a_price-768.webp
// module id = 624
// module chunks = 0